'use client';

import dynamic from 'next/dynamic';
import type { FooterTranslations } from '../../i18n/translationProps';

const Footer = dynamic(() => import('./Footer').then(m => ({ default: m.Footer })));

interface LazyFooterProps {
  translations: FooterTranslations;
}

export function LazyFooter({ translations }: LazyFooterProps) {
  return <Footer translations={translations} />;
}
